import { clearBatches, requestBatches } from './batches';
import { login } from './api';
import { getAuth, setAuth, removeAuth } from './authentication.localStorage';
import { changeCulture, getLanguageContext, setLoginLanguagePrompt } from './general';
import { getCulture } from './culture';

const LOGIN_REQUEST = 'LOGIN_REQUEST';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILURE = 'LOGIN_FAILURE';
const LOGOUT_REQUEST = 'LOGOUT_REQUEST';

const requestLogin = () => {
	return {
		type: LOGIN_REQUEST
	};
};

const requestLogout = () => {
	return {
		type: LOGOUT_REQUEST
	};
}

const receiveLogin = () => {
	return {
		type: LOGIN_SUCCESS
	};
};

const loginError = (message) => {
	return {
		type: LOGIN_FAILURE,
		message
	};
};

const logoutUser = () => {
	return dispatch => {
		dispatch(clearBatches());
		dispatch(requestLogout());
		removeAuth();
		return Promise.resolve();
	};
}


const loginUser = (code, customerId, culture) => {
	//add customerId to Datadog logs
	if (window.DD_LOGS) {
		setTimeout(() => window.DD_LOGS.addLoggerGlobalContext('customerId', customerId), 0);
	}

	return (dispatch, getState) => {
		dispatch(requestLogin());

		return login('token', code, customerId, culture)
			.then(response => {
				if (response.status >= 400) {
					dispatch(loginError());

					return {
						success: false
					}
				}

				setAuth(response.data.access_token);

				// Resolve the user's saved/resolved language BEFORE marking authenticated,
				// so the survey list loads in the correct language (no flash) and the
				// login-context prompt is ready. Saved preference always wins (WIT-10944-safe).
				// Best-effort AND bounded: neither a failure nor a hung request may block
				// login, so race the lookup against a timeout and fall through to receiveLogin.
				const languageContext = Promise.race([
					dispatch(getLanguageContext()),
					new Promise((resolve) => setTimeout(() => resolve({ success: false }), 4000))
				]);

				return languageContext
					.then(ctx => {
						if (ctx && ctx.success) {
							const displayed = getCulture(getState());
							if (ctx.savedCulture) {
								if (ctx.savedCulture !== displayed) {
									dispatch(changeCulture(ctx.savedCulture));
								}
							} else if (ctx.resolvedCulture && ctx.resolvedCulture !== displayed) {
								dispatch(setLoginLanguagePrompt({
									context: 'login',
									newCulture: displayed,
									currentCulture: ctx.resolvedCulture
								}));
							}
						}
					})
					.catch(() => { /* language resolution failed — still log the user in */ })
					.then(() => {
						dispatch(receiveLogin());
						return { success: true };
					});
			});
	};
};

export {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
	LOGOUT_REQUEST,
	requestLogin,
	receiveLogin,
	loginError,
	loginUser,
	logoutUser,
	requestLogout
}
